import React from "react";
import { StyledBackgroundImage } from "../../framework/lazy/StyledBgImage";
import { StandardImageWrapper, Caption, ImageContainer } from "./";
export const StandardImage = ({ src, byline }) => {
	return (
		<ImageContainer>
			{ src?.length ? <StandardImageWrapper minHeight="350px">
				<StyledBackgroundImage
					noRadiusBottom={byline.length > 0}
					bgImage={src}
					fadeIn={true}
				/>
			</StandardImageWrapper> : null }
			<Caption byline={byline} />
		</ImageContainer>
	);
};
